import { Button, Link, Section } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { VendImage } from '@vend/react-utilities'
import React from 'react'

export interface InvalidProductAccessPageProps {
  /**
   * Restarts the OIDC flow. Authome relies on the `sso_error=user_not_provisioned`
   * being forwarded to it so that it re-prompts with `prompt=login`.
   */
  onBackToLogin: () => void
  isSubmitting?: boolean
}

export const InvalidProductAccessPage: React.FC<
  InvalidProductAccessPageProps
> = ({ onBackToLogin, isSubmitting = false }) => {
  const t = useT()

  return (
    <div
      className="vd-flex vd-flex--justify-center vd-flex--align-center"
      style={{
        height: '100%',
        backgroundColor: 'var(--ls-color-bg-neutral-top)',
      }}
    >
      <Section>
        <div className="vd-align-center" style={{ maxWidth: '480px' }}>
          <VendImage
            width={180}
            relativeImagePath="error/wrong-user-permissions-v3.svg"
            alt={t('No permission', {
              _context: 'Invalid product access',
            })}
          />
          <h1 className="vd-text-heading vd-mt4 vd-mb2">
            {t('You don’t have access to this store', {
              _context: 'Invalid product access - heading',
            })}
          </h1>
          <p className="vd-pb5">
            {t(
              'Your account doesn’t include access to this store. Contact your account admin to request access.',
              {
                _context: 'Invalid product access - description',
              }
            )}
          </p>
          <Button
            block
            data-track="invalid-product-access-back-to-login"
            data-testid="invalid-product-access-back-to-login"
            loading={isSubmitting}
            onClick={onBackToLogin}
          >
            {t('Back to log in', {
              _context: 'Invalid product access - Button',
            })}
          </Button>
          <p className="vd-mt5">
            <Link
              data-track="invalid-product-access-need-help"
              isSecondary
              href="https://x-series-support.lightspeedhq.com/hc"
              rel="noopener noreferrer"
              target="_blank"
            >
              {t('Need help?', {
                _context: 'Invalid product access - help link',
              })}
            </Link>
          </p>
        </div>
      </Section>
    </div>
  )
}
